import { createIcon } from '../utils';

export const TailViewIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0.700195 5.19922H14.2002M5.2002 5.19922L5.2002 14.1992M4.3002 0.699219H10.6002C11.8603 0.699219 12.4904 0.699219 12.9717 0.944454C13.395 1.16017 13.7392 1.50438 13.955 1.92774C14.2002 2.40904 14.2002 3.0391 14.2002 4.29922V10.5992C14.2002 11.8593 14.2002 12.4894 13.955 12.9707C13.7392 13.3941 13.395 13.7383 12.9717 13.954C12.4904 14.1992 11.8603 14.1992 10.6002 14.1992H4.3002C3.04008 14.1992 2.41002 14.1992 1.92872 13.954C1.50535 13.7383 1.16115 13.3941 0.945431 12.9707C0.700195 12.4894 0.700195 11.8593 0.700195 10.5992V4.29922C0.700195 3.0391 0.700195 2.40904 0.945431 1.92774C1.16115 1.50438 1.50535 1.16017 1.92872 0.944454C2.41002 0.699219 3.04008 0.699219 4.3002 0.699219Z"
        stroke="currentColor"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'TailViewIcon',
  },
);
